export default __webpack_public_path__ + "static/media/image_0090.0ea61563.jpg";